import { styled } from '@arpeggi/ui'

const Root = styled('div', {
  position: 'relative',
  overflow: 'hidden',
  borderRadius: '16px',
  background: '$white',
  boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.06)',
  '&::after': {
    content: '',
    display: 'block',
    paddingBottom: '100%'
  }
})

const Content = styled('div', {
  width: '100%',
  height: '100%',
  position: 'absolute'
})

export const PlayerWrapper = { Root, Content }
